import { useState } from "react";
import { ChevronDown } from "../icons/chevron";


export default function CustomAccordion({
    title,
    children,
    defaultOpen = false,
}) {
    const [open, setOpen] = useState(defaultOpen);

    return (
        <div className="">
            <div
                onClick={() => setOpen(!open)}
                className="w-full flex items-center justify-between pl-[56px] pr-[22px] lg:pr-[56px] py-2 text-left cursor-pointer"
            >
                <h4 className="text-[13px] 2xl:text-[16px] text-[var(--goldLite)]">
                    {title}
                </h4>

                <div className={`transition-transform duration-300 ${open ? "rotate-180" : ""}`}>
                    <ChevronDown width={18} height={18} />
                </div>
            </div>

            <div
                className={`overflow-hidden transition-all duration-300 ${open ? "max-h-[500px] opacity-100" : "max-h-0 opacity-0"
                    }`}
            >
                <div className="">
                    {children}
                </div>
            </div>
        </div>
    );
}